import React from 'react';

interface DeviceMaterialLink {
  label: string;
  href: string;
}

const deviceManualIpadPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('디벗 기기 매뉴얼_아이패드.pdf');
const deviceManualAndroidPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('디벗 기기 매뉴얼_안드로이드.pdf');
const deviceAsSchoolGuidePdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('서울특별시교육청 창의미래교육과_붙임1_디벗 AS  운영 관련 학교 안내 자료.pdf');
const deviceSelfChecklistPdfPath =
  '/pdfs/info-chief/' + encodeURIComponent('서울특별시교육청 창의미래교육과_붙임4_디벗 스마트기기 관리(자체) 점검표.pdf');
const debutIntegratedCallCenterPhone = '1566-6647';

const deviceMaterialsByPlatform: Record<
  'android' | 'chromebook' | 'ios' | 'whale',
  { title: string; items: DeviceMaterialLink[] }
> = {
  android: {
    title: '안드로이드',
    items: [
      { label: '디벗 기기 매뉴얼 (안드로이드)', href: deviceManualAndroidPdfPath },
      { label: '디벗 AS 운영 관련 학교 안내 자료', href: deviceAsSchoolGuidePdfPath }
    ]
  },
  chromebook: { title: '크롬북', items: [] },
  ios: {
    title: 'iOS',
    items: [{ label: '디벗 기기 매뉴얼 (아이패드)', href: deviceManualIpadPdfPath }]
  },
  whale: { title: '네이버 웨일', items: [] }
};

const commonDeviceMaterialLinks: DeviceMaterialLink[] = [
  { label: '디벗 스마트기기 관리(자체) 점검표 양식 보기', href: deviceSelfChecklistPdfPath }
];

const DeviceMaterialsSection: React.FC = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <div style={{ border: '1px solid var(--Color-line-normal, #F0F0F0)', borderRadius: '12px', backgroundColor: 'var(--Color-background-main, #F4F6FA)', padding: '18px' }}>
        <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700, marginBottom: '8px' }}>안내</div>
        <p style={{ margin: 0, fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
          운영체제·브라우저별로 나눈 교내 안내·점검 자료를 정리합니다. PDF 등은 저장소{' '}
          <code style={{ fontSize: '13px', backgroundColor: 'white', padding: '2px 6px', borderRadius: '6px', border: '1px solid var(--Color-line-normal, #F0F0F0)' }}>
            public/pdfs/info-chief/devices/
          </code>{' '}
          하위 폴더(안드로이드, 크롬북, ios, whale)에 두고 아래 목록에 링크를 추가하세요.
        </p>
        <p style={{ margin: '8px 0 0', fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-normal, #161616)', fontWeight: 600 }}>
          디벗 통합 콜센터: {debutIntegratedCallCenterPhone}
        </p>
        <p style={{ margin: '6px 0 0', fontSize: '13px', lineHeight: '20px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
          출처: 서울특별시교육청
        </p>
      </div>

      <div
        style={{
          border: '1px solid var(--Color-line-normal, #F0F0F0)',
          borderRadius: '12px',
          backgroundColor: 'white',
          padding: '18px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px'
        }}
      >
        <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700 }}>공용 자료</div>
        <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {commonDeviceMaterialLinks.map((item) => (
            <li key={item.href} style={{ fontSize: '14px', lineHeight: '21px' }}>
              <a
                href={item.href}
                target="_blank"
                rel="noreferrer"
                style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)', fontWeight: 600 }}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '12px' }}>
        {(Object.keys(deviceMaterialsByPlatform) as Array<keyof typeof deviceMaterialsByPlatform>).map((key) => {
          const block = deviceMaterialsByPlatform[key];
          return (
            <div
              key={key}
              style={{
                border: '1px solid var(--Color-line-normal, #F0F0F0)',
                borderRadius: '12px',
                backgroundColor: 'white',
                padding: '18px',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
              }}
            >
              <div style={{ fontSize: '18px', lineHeight: '27px', fontWeight: 700 }}>{block.title}</div>
              {block.items.length === 0 ? (
                <p style={{ margin: 0, fontSize: '14px', lineHeight: '21px', color: 'var(--Color-text-assistive-strong, #4C4C4C)' }}>
                  등록된 자료가 없습니다. <code style={{ fontSize: '13px' }}>DeviceMaterialsSection.tsx</code>의 해당 배열에 항목을 추가하세요.
                </p>
              ) : (
                <ul style={{ margin: 0, paddingLeft: '18px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {block.items.map((item) => (
                    <li key={item.href} style={{ fontSize: '14px', lineHeight: '21px' }}>
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: 'var(--Color-fill-brand-color, #FF6F0F)', fontWeight: 600 }}
                      >
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DeviceMaterialsSection;
